var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("mdfeTranslate.ExportByInvoiceKeyOrBusinessOrderNumber"),
        visible: _vm.dialogVisible,
        "label-position": "top",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.onClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "100px",
            size: "small",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.ruleForm.dataType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "dataType", $$v)
                            },
                            expression: "ruleForm.dataType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("mdfeTranslate.InvoiceSecretKey"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("receivablePayable.TicketNumber"),
                              value: 2,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("basicData.InvoiceNumber"),
                              value: 3,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("collectionCenter.businessT") } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                          },
                          model: {
                            value: _vm.ruleForm.businessType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "businessType", $$v)
                            },
                            expression: "ruleForm.businessType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("collectionCenter.expressDelivery"),
                              value: 0,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("collectionCenter.collect"),
                              value: 1,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-form-item", { attrs: { label: " " } }, [
                    _c("div", { ref: "download1" }, [
                      _c(
                        "span",
                        {
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function ($event) {
                              return _vm.initDown()
                            },
                          },
                        },
                        [
                          _c("span", { staticStyle: { color: "#409eff" } }, [
                            _vm._v(
                              "cte导出模板(Modelo de Exportação de CTE).txt"
                            ),
                          ]),
                          _c("span", {
                            staticClass: "el-icon-download",
                            staticStyle: {
                              color: "#409eff",
                              "margin-left": "20px",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: " ", prop: "orderNumber" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "demoUpload",
                          staticClass: "upload-demo",
                          attrs: {
                            "before-upload": _vm.beforeUpload,
                            "file-list": _vm.ruleForm.orderNumber,
                            "http-request": _vm.upLoad,
                            limit: 1,
                            "on-exceed": _vm.handleExceed,
                            "on-remove": _vm.handleRemove,
                            accept: "text/plain",
                            action: "",
                            drag: "",
                            multiple: "",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "el-icon-plus",
                            staticStyle: { margin: "50px auto 20px" },
                          }),
                          _c("div", { staticClass: "el-upload__text" }, [
                            _vm._v(_vm._s(_vm.$t("orderImport.cldrUpload"))),
                          ]),
                          _c("div", { staticClass: "el-upload__text" }, [
                            _vm._v(
                              _vm._s(_vm.$t("spareNumberPoo.PleaseUploadTXT"))
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onClose } }, [
            _vm._v(_vm._s(_vm.$t("basicData.Cancel"))),
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
            [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }